export default {"src":"/_next/static/media/warranty-forever.02571d9f.svg","height":30,"width":30,"blurWidth":0,"blurHeight":0};